var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsercircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.075 11.2a4.125 4.125 0 11-8.25 0 4.125 4.125 0 018.25 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.533 3.843A9.75 9.75 0 0111.95 2.2a9.761 9.761 0 019.75 9.75A9.75 9.75 0 116.533 3.843zm9.291 11.43a7.472 7.472 0 012.29 2.153 8.25 8.25 0 10-12.329 0 7.473 7.473 0 012.29-2.154 5.61 5.61 0 007.75 0z",
    fillRule: "evenodd"
  }))));
}

export default SvgUsercircle;